export default {
  cardTitle: {
    id: 'checkout_back_market_promise_card_title',
    defaultMessage: 'Backed by us, not just the seller',
  },
  oneYearWarrantyTitle: {
    id: 'checkout_back_market_promise_card_one_year_warranty_title',
    defaultMessage: 'Free 1-year warranty included',
  },
  oneYearWarrantyDescription: {
    id: 'checkout_back_market_promise_card_one_year_warranty_description',
    defaultMessage:
      'That’s way longer compared to other retailers like Amazon’s 90-day warranty.',
  },
  free30DayReturns: {
    id: 'checkout_back_market_promise_card_free_30_day_returns',
    defaultMessage: 'Free 30-day returns',
  },
  realCustomerCare: {
    id: 'checkout_back_market_promise_card_real_customer_care',
    defaultMessage: 'Real customer care',
  },
}
